import React, { FC, useState } from 'react'
import { IoInformationCircle } from 'react-icons/io5'

type TooltipProps = {
  children: string | React.ReactNode
  size?: 'small' | 'default'
}

const Tooltip: FC<TooltipProps> = ({ children, size = 'default' }: TooltipProps) => {
  const [isVisible, setIsVisible] = useState(false)

  const iconSize = { small: '1.2rem', default: '1.6rem' }
  const iconPosition = { small: '-4rem', default: '-3.8rem' }

  return (
    <div className="tooltip-container" onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)}>
      <IoInformationCircle size={iconSize[size]} className="info-icon" />
      <div className={`tooltip-content ${!isVisible && 'fade-out'}`} style={{ left: iconPosition[size] }}>
        <p className="text-small tooltip-text text-gray-1">{children}</p>
      </div>
    </div>
  )
}

export default Tooltip
